module.exports = __webpack_public_path__ + "img/monpass-14ar.dfe56189.jpg";